import React, { useState, useRef, useEffect, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Header from "./Components/common/Header";
import Menu from "./Components/common/Summary_Menu";
import "./Styles/1_Mainpage.css";
import MainMap from "./Components/Main/MainMap";

const theme = createTheme();

function MainPage() {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [smartPoleData, setSmartPoleData] = useState([]); // SmartPole 데이터 상태
  const [droneData, setDroneData] = useState([]); // 드론 데이터 저장
  const [filterID, setFilterID] = useState([]); // 표시할 Clebine 및 Drone ID 관리
  const mapSectionRef = useRef(null); // MapSection에 대한 참조

  const handleMenuicon = () =>
    setIsMenuActive((prev) => {
      const next = !prev; // 토글된 값
      console.log("[Menu] isMenuActive →", next);
      return next; // 이 값을 React state 로 반영
    });

  // #endregion
  // #region 함수들

  // useMemo를 사용하여 filterID 계산
  const memoizedFilterID = useMemo(() => {
    if (smartPoleData.length === 0 && droneData.length === 0) return filterID;

    const allIDs = [
      ...smartPoleData.map((row) => `clebine-${row.id}`),
      ...droneData.map((drone) => `drone-${drone.droneId}`),
    ];

    return allIDs;
  }, [smartPoleData, droneData]);

  // filterID 상태 업데이트
  useEffect(() => {
    setFilterID(memoizedFilterID);
  }, [memoizedFilterID]);

  /*=====================================================================*/
  // #endregion
  return (
    <ThemeProvider theme={theme}>
      <Header onMenuicon={handleMenuicon} isMenuActive={isMenuActive} />
      <main className="main-page main">
        <MainMap />
        <Menu onMenuicon={handleMenuicon} isMenuActive={isMenuActive} />
      </main>
    </ThemeProvider>
  );
}

export default MainPage;
